import { useAppContext } from "../../../../classes/contexts/AppContext";
import { usePatientContext } from "../../../../classes/contexts/PatientContext";
import { useUser } from "../../../../classes/contexts/UserContext";
import { ButtonSize } from "../../../../classes/enums/ButtonEnum";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import { formatDateWithTimeInZone } from "../../../../classes/utils/DateUtils";
import IconButton from "../../../../components/iconButton/IconButton";
import DeleteClinicalHistoryModal from "./DeleteClinicalHistoryModal";
import "./ClinicalHistory.css";
import ClinicalHistoryModal from "./ClinicalHistoryModal";

const ClinicalHistoryItem = ({ history, canDelete = false, onHistoryDeleted }) => {
  const { showPopup } = useAppContext();
  const { patient } = usePatientContext();
  const { userPreferences, dateSettings } = useUser();
  const timeZone =
    userPreferences?.display_settings?.timezone?.toString() || "UTC";

  const handleClick = () => {
    showPopup(
      <ClinicalHistoryModal
        existingHistory={history}
        patientId={patient?._id}
      />
    );
  };

  const handleDeleteClick = event => {
    event.stopPropagation();
    showPopup(
      <DeleteClinicalHistoryModal
        history={history}
        onHistoryDeleted={onHistoryDeleted}
      />
    );
  };

  const displayDate = formatDateWithTimeInZone(
    history?.createdAt || history?.updatedAt,
    timeZone,
    { locale: dateSettings?.locale }
  );

  return (
    <div className="clinical-history-item" onClick={handleClick}>
      <div className="clinical-history-item-name App-text-medium">
        Medical Record
      </div>
      <div className="clinical-history-item-right">
        <div className="clinical-history-item-date App-text-medium">
          {displayDate}
        </div>
        {canDelete && (
          <div className="clinical-history-delete-action">
            <IconButton
              icon={IconsEnum.DELETE}
              size={ButtonSize.SMALL}
              noBgColor
              title="Delete Medical History"
              onClick={handleDeleteClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClinicalHistoryItem;
